<home *ngIf="(auth.isAuthenticated$ | async) === false; else mainContent"> </home>

<ng-template #mainContent>
  <div id="main-grid-panel">
    <div class="deep-link-overlay" *ngIf="deepLinkLoading">
      <p-progressSpinner strokeWidth="4"></p-progressSpinner>
      <span>Opening…</span>
    </div>
    <as-split direction="horizontal" [useTransition]="true" (dragEnd)="splitDragEvent($event)" >
      <as-split-area [size]=20 class="left-panel-area">
        <!-- <div class="col flex justify-content-center"> -->
        <p-tabMenu
          #filesDetailsTabMenu
          [model]="itemsTabMenu | slice : 0 : 4"
          [activeItem]="(activeItemL$ | async)!"
        ></p-tabMenu>

        <div *ngIf="activeItemL$ | async as activeItemL" class="left-panel-content"
             [hidden]="activeItemL.id === 'search'">
          <ng-container *ngIf="activeItemL.id === 'files'">
            <div class="w-full col-12 md:col-3">
              <p-dropdown
                [style]="{ width: '100%' }"
                placeholder="Select Bucket"
                [options]="projects"
                optionLabel="name"
                [disabled]="projects.length <= 0"
                (onChange)="onProjectSelect($event)"
                [dropdownIcon]="loadingDropdown()"
              ></p-dropdown>
            </div>

            <file-tree
              *ngIf="this.mainFacade.getSelectedProject$() | async"
              (interuptPreview)="interuptPreview()"
              (processSelected)="processSelected()"
              (nodeExpand)="nodeExpand($event)"
              (nodeSelect)="nodeSelect($event)"
            ></file-tree>
          </ng-container>

          <ng-container *ngIf="activeItemL.id === 'details'">
            <cimg-details></cimg-details>
          </ng-container>

          <!-- Stays mounted once opened (like file-search below) so results
               persist across tab switches instead of re-fetching every time -->
          <results-tab *ngIf="resultsTabActivated" [hidden]="activeItemL.id !== 'results'"></results-tab>
        </div>

        <!-- Search component stays mounted so results persist and background search continues -->
        <file-search [hidden]="(activeItemL$ | async)?.id !== 'search'"></file-search>
        <!-- </div> -->
      </as-split-area>
      <as-split-area [size]=60>
        <file-viewer></file-viewer>
      </as-split-area>
      <as-split-area [size]=20 class="right-panel-area">
        <p-tabMenu
          #processQueueTabMenu
          [model]="itemsTabMenu | slice : 4 : 7"
          [activeItem]="(activeItemR$ | async)!"
        ></p-tabMenu>

        <div *ngIf="activeItemR$ | async as activeItemR" class="right-panel-content">
          <ng-container *ngIf="activeItemR.id === 'process'">
            <process></process>
          </ng-container>

          <process-status *ngIf="activeItemR.id === 'queue'"></process-status>

          <rules *ngIf="activeItemR.id === 'rules'"></rules>
        </div>
      </as-split-area>
    </as-split>
  </div>
</ng-template>

<p-toast position="center" key="center-toast"></p-toast>

